import React, { Component } from 'react';

class FoodItem extends Component {
  formatPrice(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  render() {
	  const isFeatured = (this.props.item.featured);
	  const featuredClass = (isFeatured) ? 'featured' : '';

    return (
      <div className={`food-item-block ${featuredClass}`}>
        <div className="name">
          {this.props.item.name}
        </div>
        <div className="description">
          {this.props.item.description}
        </div>
        <div className="price">
          {this.formatPrice(this.props.item.price)}
        </div>
      </div>
    );
  }
}

export default FoodItem;
